import { render, staticRenderFns } from "./dp.vue?vue&type=template&id=4629a60d&scoped=true&"
import script from "./dp.vue?vue&type=script&lang=js&"
export * from "./dp.vue?vue&type=script&lang=js&"
import style0 from "./dp.vue?vue&type=style&index=0&id=4629a60d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629a60d",
  null
  
)

export default component.exports